import Vue from 'vue'

export default {

    /**
     * Retrieve the experiments from the API
     *
     * @param {string} group
     * @param {int} participantsHistory
     * @return {Promise<*>}
     */
    async getExperiments(group, participantsHistory) {
        let res = await Vue.axios.get('/experiments', {
            params: {
                group: group,
                participants_history: participantsHistory
            }
        })

        return res.data
    },

    /**
     * Create new experiment
     *
     * @param experiment
     * @returns {Promise<void>}
     */
    async newExperiment(experiment) {
        let body = {
            title: experiment.title,
            group: experiment.group,
            variants: [],
            segmentation: []
        }

        experiment.variants.forEach(function(value) {
           if (value !== '') {
               body.variants.push(value.variant)
           }
        })

        let res = await Vue.axios.post('/experiments', body)

        return res
    }
}
